import { createEventEmitter } from '@reckon-web/events';

type AppSwitcherEvents = {
  onClose: () => void;
};

export const appSwitcherEventEmitter = createEventEmitter<AppSwitcherEvents>();
